import { Box, Fade } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const TileGroup: FC<Props> = ({ children }) => {
  return (
    <Fade
      in
      appear
      timeout={100}
      easing={{
        enter: 'ease-in',
        exit: 'ease-out',
      }}
    >
      <Box width="100%">{children}</Box>
    </Fade>
  );
};

export default TileGroup;
